import { createAction, props } from '@ngrx/store';
import { Brand } from '../domain/brand';
import { Feed } from '../domain/feed';
import { Rating } from '../domain/rating';

const feature = '[Content group]';

export const fetchFeed = createAction(`${feature} Fetch feed`, props<{ term: string }>());
export const fetchFeedSuccess = createAction(`${feature} Fetch feed success`, props<{ feeds: Feed[] }>());
export const fetchFeedFail = createAction(`${feature} Fetch feed fail`, props<{ errorMessage: string }>());

export const fetchBrands = createAction(`${feature} Fetch brands`);
export const fetchBrandsSuccess = createAction(`${feature} Fetch brands success`, props<{ brands: Brand[] }>());
export const fetchBrandsFail = createAction(`${feature} Fetch brands fail`, props<{ errorMessage: string }>());

export const fetchRatings = createAction(`${feature} Fetch ratings`);
export const fetchRatingsSuccess = createAction(`${feature} Fetch ratings success`, props<{ ratings: Rating[] }>());
export const fetchRatingsFail = createAction(`${feature} Fetch ratings fail`, props<{ errorMessage: string }>());
